/** Swing: autoComplete.contains("Multiple") */
export function isAutocompleteMultipleMode(autoComplete: string | undefined | null): boolean {
  return String(autoComplete ?? '')
    .trim()
    .toLowerCase()
    .includes('multiple')
}

export function isFinitePositiveMultipleLimit(limit: number | null | undefined): boolean {
  return typeof limit === 'number' && limit > 0 && Number.isFinite(limit)
}

/**
 * Закрывать popup после выбора пункта (JJMouseClickSuggester).
 * — onClick: всегда;
 * — onClickMultiple + limit: только когда набрано limit значений;
 * — onClickMultiple без limit: не на ЛКМ (закрытие на blur).
 */
export function shouldCloseAutocompleteAfterSelect(options: {
  isMultipleMode: boolean
  multipleLimit: number | null | undefined
  selectedCountAfter: number
}): boolean {
  if (!options.isMultipleMode) return true
  if (!isFinitePositiveMultipleLimit(options.multipleLimit)) return false
  return options.selectedCountAfter >= (options.multipleLimit as number)
}

export function isAtMultipleSelectionLimit(options: {
  isMultipleMode: boolean
  multipleLimit: number | null | undefined
  selectedCount: number
}): boolean {
  return (
    options.isMultipleMode &&
    isFinitePositiveMultipleLimit(options.multipleLimit) &&
    options.selectedCount >= (options.multipleLimit as number)
  )
}

/** Swing: autoComplete.contains("onClick") */
export function isOnClickAutocomplete(autoComplete: string | undefined | null): boolean {
  return String(autoComplete ?? '')
    .trim()
    .toLowerCase()
    .includes('onclick')
}

/** Swing: "true".equals(enableSuggestEdit) */
export function isSuggestEditEnabled(enableSuggestEdit: string | undefined | null): boolean {
  return String(enableSuggestEdit ?? '').trim().toLowerCase() === 'true'
}

/**
 * Справочник без свободного ввода: onClick / onClickMultiple и enableSuggestEdit не true.
 */
export function isSelectOnlySuggester(
  autoComplete: string | undefined | null,
  enableSuggestEdit: string | undefined | null,
): boolean {
  return isOnClickAutocomplete(autoComplete) && !isSuggestEditEnabled(enableSuggestEdit)
}
